import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './assets/font/font.scss'
// import './registerServiceWorker'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import './styles/element-variables.scss'

Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// export default Vue
